import type { BoxProps } from '@mui/material/Box';
import type { IEventItemProps } from 'src/types/product';

import { useDispatch, useSelector } from 'react-redux';

import Box from '@mui/material/Box';
import Pagination, { paginationClasses } from '@mui/material/Pagination';

import { paths } from 'src/routes/paths';

import { setPaginationParent } from 'src/context/activitiesAndBlogs/parent_activitiesAndBlogs';
import { setPaginationAnonymous } from 'src/context/activitiesAndBlogs/anonymous_activitiesAndBlogs';

import { EmptyContent } from 'src/components/empty-content';

import { ProductItem } from './product-item';
import { ProductItemSkeleton } from './product-skeleton';

// ----------------------------------------------------------------------
type Props = BoxProps & {
  loading?: boolean;
  products: IEventItemProps[];
  productsCount: number;
};

export function ProductList({ products, productsCount, loading, sx, ...other }: Props) {
  const dispatch = useDispatch();
  const accessTokenJSON = localStorage.getItem('auth') as string;
  const accessToken = JSON.parse(accessTokenJSON)?.accessToken ?? null;
  const {
    page: activePage,
    anonymous_activitiesAndBlogsLoading: isLoading,
    parent_actitiesAndBlogsLoading: isLoading2,
  } = useSelector((state: any) =>
    accessToken ? state.parent_activitiesAndBlogs : state.anonymous_activitiesAndBlogs
  );

  const renderLoading = () => <ProductItemSkeleton />;

  const renderList = () =>
    products?.map((product) => (
      <ProductItem
        key={product._id}
        product={product}
        detailsHref={
          product.plus
            ? paths.post.details(product._id)
            : product.isBlog
              ? paths.blog.details(product._id)
              : paths.aktivite.details(product._id)
        }
        entityType={product.isBlog ? 'blog' : 'aktivite'}
      />
    ));

  const handlePaginition = (page: number) => {
    if (accessToken) {
      dispatch(setPaginationParent(page ?? 1));
    } else {
      dispatch(setPaginationAnonymous(page ?? 1));
    }
  };

  return (
    <>
      {products && products.length === 0 && (
        <EmptyContent
          title="Aktivite Bulunamadı"
          description=""
          sx={{
            mt: 10,
            justifyContent: 'flex-start',
          }}
        />
      )}

      <Box
        sx={[
          () => ({
            gap: 3,
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(2, 1fr)',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
        {...other}
      >
        {loading || isLoading || isLoading2 ? renderLoading() : renderList()}
      </Box>

      {productsCount > 15 &&
        (() => (
          <Pagination
            count={Math.ceil(productsCount / 15)}
            page={activePage || 1}
            onChange={(_, page) => handlePaginition(page ?? 1)}
            sx={{
              mt: { xs: 5, md: 8 },
              [`& .${paginationClasses.ul}`]: { justifyContent: 'center' },
            }}
          />
        ))()}
    </>
  );
}
